import { version } from "../../../package.json";
import type { MainStoreState } from "../../types/MainStoreState.js";
import { alertMode } from "../data/alert-mode.js";

window.localStorage.setItem("webVersion", version);

// I have to think about how to better handle this kinda of value
// These are options saved in localStorage that should have a default value
// Maybe it should come from the server...?
if (window.localStorage.getItem("alertMode") === null) {
  window.localStorage.setItem("alertMode", alertMode.default);
}

const propertiesFromLocalStorageToMemory = [
  "acknowledgeButton",
  "activatedAt",
  "alertMode",
  "browserCommand",
  "channel",
  "computerName",
  "desktopVersion",
  "emsAgencyId",
  "group",
  "hospital",
  "hospitalId",
  "lastPubNubMessageTimetoken",
  "machine",
  "machineId",
  "name",
  "productKey",
  "publishKey",
  "silenceButton",
  "ssoProvider",
  "ssoSubdomain",
  "subscribeKey",
  "webVersion",
].reduce<Record<string, string>>((object, property) => {
  object[property] = window.localStorage.getItem(property) || "";

  return object;
}, {});

export const state = (): MainStoreState => ({
  acknowledgeButton: "",
  activatedAt: "",
  alertMode: alertMode.notifyOnly,
  browserCommand: "",
  caseTracker: {},
  channel: "",
  computerName: "",
  connected: null,
  desktopVersion: "",
  emsAgencyId: "",
  group: "",
  hospital: "",
  hospitalId: "",
  logEntryWriteFailureCount: 0,
  lastCaseID: "",
  lastCaseNumber: "",
  lastInteraction: "",
  lastInteractionTime: 0,
  lastPubNubMessageReceivedTime: 0,
  lastPubNubMessageTimetoken: "",
  latestInstallerVersion: "",
  linkToLatestInstaller: "",
  machine: "",
  machineId: "",
  messagingServersConnectivityCheckResponse: null,
  name: "",
  productKey: "",
  pubNubStatusTracker: [],
  publishKey: "",
  pubnub: null,
  showOptions: window.localStorage.getItem("showOptions") === "true",
  silenceButton: "",
  ssoProvider: "",
  ssoSubdomain: "",
  subscribeKey: "",
  webVersion: "",
  ...propertiesFromLocalStorageToMemory,
});
